// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toaster_toast__knUyB","error":"Toaster_error__8Za5n","success":"Toaster_success__214SM","icon":"Toaster_icon__pUGRc"};